const intialState = {
    classification: '',
    cnn: '',
    date_entree_entreprise: '',
    date_naissance: '',
    email: '',
    id: '',
    id_niv_formation: '',
    id_societe: '',
    intitule_formation: '',
    logo: '',
    niv_formation: '',
    nom: '',
    nom_societe: '',
    num_salarie: '',
    photo: '',
    prenom: '',
    projet: '',
    formations: []
};

export default function reducer(state = intialState, action) {

    switch (action.type) {
        case "GET_INFOS_SALARIE_FULFILLED": {
            return action.payload.data
        }
        default: {
            return state;
        }
    }
};


// WEBPACK FOOTER //
// ./src/reducers/salarie/infos.js